import { render, staticRenderFns } from "./WorkflowPrepTaskAuditTrail.vue?vue&type=template&id=52d0a89d"
import script from "./WorkflowPrepTaskAuditTrail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepTaskAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports